<template>
  <div>
    <!--导航栏 start-->
    <div class="nav-bar">
      <van-nav-bar left-text="返回" fixed title="微信认证" left-arrow @click-left="onClickLeft">
       
      </van-nav-bar>
    </div>
    <!--导航栏 end-->
    <div class="box">
      <!-- 二维码生成区-->
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        @click="show = true"
        required
        :rules="[{ required: true, message: '省区县必选' }]"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>
      <!-- <van-field
      name="address"
      v-model="address"
      label="受益人身份证地址"
      placeholder="请输入受益人身份证地址"
      required
      clearable
      clickable
      :rules="[{ required: true, message: '请输入受益人身份证地址' }]"
      />-->
      <div style="margin: 16px">
        <van-button round block type="info" @click="submit">确定</van-button>
      </div>
      <img v-if="url" :src=" 'data:image/png;base64,' + url" class="img" />
      <div
        v-if="state == 'APPLYMENT_STATE_WAITTING_FOR_AUDIT'"
        class="shnehezhong"
      >审核中请耐心等待1~2个工作日，微信支付将会完成审核</div>
      <div
        v-if="state == 'APPLYMENT_STATE_EDITTING'"
        class="shnehezhong"
      >编辑中，可能提交申请发生了错误导致，可用同一个业务申请编号重新提交</div>
      <div
        v-if="state == 'APPLYMENT_STATE_WAITTING_FOR_CONFIRM_CONTACT'"
        class="shnehezhong"
      >待确认联系信息，请扫描微信支付返回的小程序码确认联系信息(此过程可修改超级管理员手机号)</div>
      <div
        v-if="state == 'APPLYMENT_STATE_WAITTING_FOR_CONFIRM_LEGALPERSON'"
        class="shnehezhong"
      >待账户验证，请扫描微信支付返回的小程序码在小程序端完成账户验证</div>
      <div
        class="shnehezhong"
        v-if="state == 'APPLYMMENT_STATE_PASSED'"
      >审核通过，请扫描微信支付返回的小程序码在小程序端完成授权流程</div>
      <div
        v-if="state == 'APPLYMENT_STATE_REJECTED'"
        class="shnehezhong"
      >审核驳回，请按照驳回原因修改申请资料，并更换业务申请编码，重新提交申请</div>
      <div
        v-if="state == 'APPLYMENT_STATE_FREEZED'"
        class="shnehezhong"
      >已冻结，可能是该主体已完成过入驻，请查看驳回原因，并通知驳回原因中指定的联系人扫描微信支付返回的小程序码在小程序端完成授权流程</div>
      <div v-if="state == 'APPLYMENT_STATE_CANCELED'" class="shnehezhong">已作废，表示申请单已被撤销，无需再对其进行操作</div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from "vant";
// import QRCode from "qrcodejs2";
import { zfbArea } from "@/assets/json/zfb_area";
export default {
  data() {
    return {
      url: "",
      state: "",
      query: "",
      show: false,
      options: zfbArea,
      fieldValue: "",
      cascaderValue: "",
      province_code: "",
      city_code: "",
      district_code: "",
      province: "",
      city: "",
      district: "",
      address: "",
    };
  },
  mounted() {
    console.log("-----", JSON.parse(this.$route.query.form));
    this.query = JSON.parse(this.$route.query.form);
    // console.log(query);
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      this.$router.go(-1)
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      console.log("-----", selectedOptions);
      this.province_code = selectedOptions[0].value;
      this.province = selectedOptions[0].text;
      this.city_code = selectedOptions[1].value;
      this.city = selectedOptions[1].text;
      this.district_code = selectedOptions[2].value;
      this.district = selectedOptions[2].text;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    submit() {
      if (!this.province_code) {
        Toast("请选择省市区");
        return;
      }
      // if (!this.address) {
      //   Toast("请填写地址");
      //   return;
      // }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      this.$http
        .get("/wechat/api.merchant/merchantAuth", {
          params: {
            merchant_id: this.query.id,
            type: this.query.type,
            province_code: this.province_code,
            city_code: this.city_code,
            district_code: this.district_code,
            province: this.province,
            city: this.city,
            district: this.district,
            // address:this.address,
          },
        })
        .then((response) => {
          console.log(response);
          Toast.clear();
          if (response && response.data.code == 200) {
            this.url = response.data.data.qrcodeData;
            this.state = response.data.data.applymentState;
            console.log(this.state);
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
  },
};
</script>
<style scoped>
.box {
  margin: 20px;
  text-align: center;
   padding-top: 46px;
}
.img {
  width: 200px;
  height: 200px;
}
.shnehezhong {
  font-size: 16px;
}
</style>